/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Planner_ManualInputs */

const en_control_planner_manual = /** @type {(inputs: Control_Planner_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy the link from the field below.`)
};

const zh_control_planner_manual = /** @type {(inputs: Control_Planner_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请从下方输入框手动复制链接。`)
};

/**
* | output |
* | --- |
* | "Copy the link from the field below." |
*
* @param {Control_Planner_ManualInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_planner_manual = /** @type {((inputs?: Control_Planner_ManualInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Planner_ManualInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_planner_manual(inputs)
	return zh_control_planner_manual(inputs)
});
export { control_planner_manual as "control.planner.manual" }